export default __webpack_public_path__ + "static/media/PROCESSMETHOD_MOLDING_BLOW_INJECTION.68feef1e.png";